"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = oneTrustPlugin;
var React = __importStar(require("react"));
var customer_notifications_1 = require("./customer-notifications");
function oneTrustPlugin(_a) {
    var CapGraphqlProvider = _a.CapGraphqlProvider;
    return {
        name: 'one-trust-plugin',
        onBrowserWrapRootElement: function (context, next) {
            var setRootElement = context.setRootElement;
            var appData = context.getAppData();
            setRootElement(function (RootElement) { return function (props) {
                var _a, _b;
                return (React.createElement(RootElement, null,
                    React.createElement(CapGraphqlProvider.GraphProvider, { graphType: "BEX", ssrConfig: (_b = (_a = appData.stores) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.appConfig },
                        React.createElement(customer_notifications_1.CustomerNotifications, { location: "LEGAL" })),
                    React.createElement(React.Fragment, null, props.children)));
            }; });
            return next(context);
        },
    };
}
//# sourceMappingURL=browser.js.map